// third-party
import { createSlice } from '@reduxjs/toolkit';

// project imports
import axios from 'utils/axios';
import { dispatch } from '../index';

// ----------------------------------------------------------------------

const initialState = {
    categoryList: [],
    selectedCategory: null,
    message: null,
    status: false,
    error: ''
};

const slice = createSlice({
    name: 'category',
    initialState,
    reducers: {
        hasError(state, action) {
            state.error = action.payload;
        },
        setCategories(state, action) {
            state.categoryList = action.payload;
        },
        setSelectedCategory(state, action) {
            state.selectedCategory = action.payload;
        },
        setCategory(state, action) {
            const data = action.payload;
            const rowIndex = state.categoryList.findIndex((item) => item.id === data.id);
            if (rowIndex) {
                state.categoryList[rowIndex] = data;
            }
        }
    }
});

// Reducer
export default slice.reducer;
export const { setSelectedCategory } = slice.actions;
// ----------------------------------------------------------------------

export function getCategories() {
    return async () => {
        try {
            const response = await axios.post('/category/list');
            if (response.data.status) {
                dispatch(slice.actions.setCategories(response.data.data));
            } else {
                dispatch(slice.actions.hasError(response.data.message));
            }
        } catch (error) {
            dispatch(slice.actions.hasError(error.message));
        }
    };
}
export function getCategory(id) {
    return async () => {
        try {
            const response = await axios.post('/category/details', { id });
            if (response.data.status) {
                dispatch(slice.actions.setCategory(response.data.data));
            } else {
                dispatch(slice.actions.hasError(response.data.message));
            }
        } catch (error) {
            console.log(error);
        }
    };
}
export function saveCategory(data) {
    return async function () {
        const response = await axios.post('category/save', data);
        return response;
    };
}

export function updateCategory(data) {
    return async function () {
        const response = await axios.post('category/update', data);
        return response;
    };
}

export function deleteCategory(data) {
    return async function () {
        const response = await axios.post('category/delete', data);
        return response;
    };
}
